/* eslint-disable no-underscore-dangle */
import { detectDevUrl } from './detectDevUrl';

const setLs = localStorage.setItem.bind(localStorage);

/**
 * Global helper utilities for changing all API request URLs to match
 * whichever location data is being accessed for development.
 */
const setDevUrlsTo = {
  local: () => {
    setLs('__api_domain', 'https://hotels.cloudbeds-local.com');
    setLs('__paym_sdk_api_url', 'https://api.cloudbeds-local.com');
    setLs('__paym_sdk_base_url', 'https://hotels.cloudbeds-local.com');
    console.info('Set API request URLs to local environment (cloudbeds-local)');
  },
  us1: () => {
    setLs('__api_domain', 'https://hotels.cloudbeds-stage.com');
    setLs('__paym_sdk_api_url', 'https://api.cloudbeds-stage.com');
    setLs('__paym_sdk_base_url', 'https://hotels.cloudbeds-stage.com');
    console.info(
      'Set API request URLs to US1 stage environment (cloudbeds-stage)',
    );
  },
  us2: () => {
    setLs('__api_domain', 'https://us2.cloudbeds-stage.com');
    setLs('__paym_sdk_api_url', 'https://api.us2.cloudbeds-stage.com');
    setLs('__paym_sdk_base_url', 'https://us2.cloudbeds-stage.com');
    console.info(
      'Set API request URLs to US2 stage environment (us2.cloudbeds-stage)',
    );
  },
  prod: () => {
    setLs('__api_domain', 'https://hotels.cloudbeds.com');
    setLs('__paym_sdk_api_url', 'https://api.cloudbeds.com');
    setLs('__paym_sdk_base_url', 'https://hotels.cloudbeds.com');
    console.info('Set API request URLs to production environment (cloudbeds)');
  },
};

if (detectDevUrl) {
  (window as any).__dev__ ??= {};
  (window as any).__dev__.setDevUrlsTo = setDevUrlsTo;
}

/** Exported to ensure tree shaking doesn't erase this */
export const globalDevUtils = { setDevUrlsTo };
